// Einstiegspunkt. Zwei Dinge passieren hier, und beide hängen an einem Zeitpunkt.
//
// 1. Die Anwendung wird NICHT statisch importiert. `@/api` wertet seine Basis-URLs beim Import als
//    Modul-Konstanten aus, und statische Importe laufen vor jeder Zeile dieser Datei. Ein
//    statischer Import würde die API-Basis festlegen, bevor `config.json` gelesen ist. Der
//    dynamische Import unten verschiebt die Auswertung hinter das Laden der Konfiguration.
//
// 2. Die Service-Worker-Registrierung wird dagegen STATISCH importiert, und zwar genau hier.
//    `register-service-worker` legt sein `load`-Promise beim Modul-Laden an. Läuft das Modul erst
//    nach dem `load`-Ereignis — und das täte es im dynamisch nachgeladenen `bootstrap.js` —,
//    löst der Listener nie aus: keine Registrierung, keine Fehlermeldung, kein Service Worker.
//    Diese Datei wird dagegen im Eintritts-Chunk ausgewertet, also lange vor `load`.
//
//    Damit das mit Punkt 1 verträglich bleibt, darf die Importkette dieser Zeile `@/api` nicht
//    erreichen. Sie führt über `usePwa` → `native/network` → `native/platform` und tut das nicht.
//    Wer sie erweitert, prüft das erneut.
//
// Der eigentliche Start steht in `bootstrap.js`.

import './registerServiceWorker'
import { loadRuntimeConfig } from './runtimeConfig'

loadRuntimeConfig().then(() => import('./bootstrap'))
